import React from 'react';
import './WhatYouGet.css';

const WhatYouGet = () => {
  const features = [
    {
      icon: "👥",
      title: "Community-Based Virtual Associates",
      description: "Our community-driven virtual associates stay longer, perform better, and grow with your business."
    },
    {
      icon: "💰",
      title: "Solutions Tailored to Your Budget",
      description: "Share your budget with us, and we'll strategically design a solution that maximizes quality without unnecessary costs."
    },
    {
      icon: "🤝",
      title: "Your Dedicated Team",
      description: "Whether you need one extra hand or a full team, we help you hire or build a reliable workforce that scales with your business."
    }
  ];

  return (
    <section className="what-you-get-section">
      {/* Blur background layer - same as your Services section */}
      <div 
        className="what-you-get-bg-blur"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero/hero-background.jpg)`
        }}
      />
      
      <div className="what-you-get-container">
        <div className="section-header">
          {/* Fixed: Removed extra space before the header */}
          <h2 className="section-title">What You Get</h2>
          {/* Fixed grammar: More complete sentence */}
          <p className="section-subtitle">
            Top talent without breaking the bank.
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatYouGet;